import { path as parentPath } from "../init";

export const path = "dailyCover";

const urlPrefix = "/api/dailyCover";

export const apiUrls = {
  dailyCover: `${urlPrefix}`,
};
